/*eslint-disable*/export const messages = {
  'Add "{inputValue}"': ["Ajouter « ", ["inputValue"], " »"],
  "All items have been removed.": "Tous les éléments ont été supprimés.",
  "Clear selection": "Effacer la sélection",
  "No results found.": "Aucun résultat trouvé.",
  "Press Enter to select or deselect an option.": "Appuyez sur Entrée pour sélectionner ou désélectionner une option.",
  "Select All": "Sélectionner tout",
  "Selected Items": "Éléments sélectionnés",
  "Toggle menu": "Menu déroulant",
  "listbox contents": "contenu de la liste",
  "{itemAsString} has been removed.": [["itemAsString"], " a été supprimé."],
  "{itemAsString} has been selected.": [["itemAsString"], " a été sélectionné."],
  "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.": [["resultCount", "plural", {
    one: ["#", " résultat est disponible"],
    other: ["#", " résultats sont disponibles"]
  }], ", utilisez les touches fléchées haut et bas pour naviguer. Appuyez sur la touche Entrée pour sélectionner."],
  "{selectedValue} selected": [["selectedValue"], " sélectionné"],
  "{totalSelectedItems} selected": [["totalSelectedItems"], " sélectionnés"],
  "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " sélectionnés. Désélectionner tout"],
  "{totalSelectedItems} selected. Select all {totalOptions} items": [["totalSelectedItems"], " sélectionnés. Sélectionner tous les éléments (", ["totalOptions"], ")"]
};
//# sourceMappingURL=messages.js.map